var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10859_1581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.51209 11.8564C0.511527 13.8729 1.04253 15.8418 2.05221 17.5772L0.415527 23.5067L6.53103 21.9156C8.22249 22.8293 10.1177 23.3081 12.0435 23.3082H12.0486C18.4062 23.3082 23.5815 18.1749 23.5842 11.8654C23.5855 8.80801 22.3866 5.93304 20.2084 3.77006C18.0306 1.60727 15.1342 0.415549 12.0481 0.414154C5.68972 0.414154 0.514809 5.54718 0.512184 11.8564",
    fill: "url(#paint0_linear_10859_1581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.100313 11.8527C0.0996563 13.9417 0.649687 15.981 1.69537 17.7786L0 23.9207L6.33478 22.2726C8.08022 23.2168 10.0454 23.7147 12.0451 23.7154H12.0502C18.636 23.7154 23.9972 18.3975 24 11.8621C24.0011 8.69488 22.7591 5.71656 20.5031 3.47609C18.2468 1.23591 15.2468 0.00130233 12.0502 0C5.46337 0 0.102938 5.31721 0.100313 11.8527ZM3.87281 17.469L3.63628 17.0965C2.64197 15.5277 2.11716 13.7149 2.11791 11.8534C2.12006 6.4213 6.57544 2.00186 12.054 2.00186C14.7071 2.00298 17.2005 3.02921 19.0759 4.89116C20.9512 6.7533 21.9831 9.22865 21.9824 11.8614C21.98 17.2935 17.5245 21.7135 12.0502 21.7135H12.0463C10.2638 21.7126 8.51569 21.2376 6.99113 20.34L6.62831 20.1265L2.86912 21.1045L3.87281 17.4689V17.469Z",
    fill: "url(#paint1_linear_10859_1581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06334 6.89749C8.83965 6.40419 8.60425 6.39424 8.39153 6.38559C8.21734 6.37814 8.01821 6.3787 7.81928 6.3787C7.62015 6.3787 7.29662 6.45303 7.02315 6.74931C6.7494 7.04587 5.97803 7.76252 5.97803 9.2201C5.97803 10.6778 7.048 12.0864 7.19715 12.2843C7.3465 12.4818 9.26275 15.5687 12.2976 16.7562C14.8199 17.7431 15.3332 17.5468 15.8806 17.4973C16.4281 17.448 17.6472 16.7808 17.8959 16.089C18.1448 15.3973 18.1448 14.8044 18.0702 14.6805C17.9956 14.557 17.7964 14.4829 17.4978 14.3348C17.1992 14.1866 15.7312 13.4699 15.4576 13.371C15.1838 13.2722 14.9848 13.2229 14.7857 13.5195C14.5865 13.8157 14.0147 14.4829 13.8405 14.6805C13.6664 14.8785 13.4921 14.9032 13.1936 14.755C12.8948 14.6063 11.9332 14.2939 10.7924 13.2847C9.90475 12.4994 9.3055 11.5296 9.13131 11.2329C8.95712 10.9367 9.11265 10.7762 9.26237 10.6286C9.39653 10.4958 9.56106 10.2826 9.7105 10.1097C9.85937 9.93666 9.90906 9.81321 10.0086 9.61563C10.1083 9.41786 10.0584 9.24484 9.98387 9.09666C9.90906 8.94847 9.32884 7.48326 9.06334 6.89749Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10859_1581",
    x1: 1158.85,
    y1: 2309.67,
    x2: 1158.85,
    y2: 0.414154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10859_1581",
    x1: 1200,
    y1: 2392.07,
    x2: 1200,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10859_1581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.e372c651e913a0abfea5354eb46b93ce.svg";
export { ForwardRef as ReactComponent };